import axios from 'axios';
import { stringify } from 'qs';
export async function getTicketDeployTemplateList(params) {
  return axios.get(`/ws/message/getTicketDeployTemplateList/4?${stringify(params)}`);
}
export async function userIint(params) {
  return axios.get(`/chat/user/init.action?${stringify(params)}`);
}
export async function getInfo(params) {
  return axios.get(`/chat/data/invokeOtherByUser.action?${stringify(params)}`);
}

export async function sendMsg(params) {
  return axios.post(`/chat/data/postMsg.action`,params);
}

export async function getTicketTypeInfoList(params) {
  return axios.post(`/chat/data/invokeOtherByUser.action?${stringify(params)}`);
}

// 获取验证码接口
export async function getCode(params) {
  return axios.get(`/chat-web/data/shortMsg?${stringify(params)}`);
}
